import { render, staticRenderFns } from "./BriefsCard.vue?vue&type=template&id=28ab33f1"
import script from "./BriefsCard.vue?vue&type=script&lang=js"
export * from "./BriefsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports